// React / Next
import { Link } from '@tanstack/react-router';

// Components
import { Typography } from '@archieai/ui';

// Hooks
import { useTrackEvent } from '../../hooks/useTrackEvent';

export const HireArchieCTA = () => {
  const trackEvent = useTrackEvent();
  return (
    <section className="flex justify-center px-[var(--spacing-24)] py-[var(--spacing-64)] w-full max-md:px-[var(--spacing-16)] max-md:py-[var(--spacing-48)]">
      <div className="relative w-full max-w-[1224px] min-h-[400px] rounded-[var(--radius-24)] overflow-hidden max-lg:min-h-[350px] max-md:min-h-[300px]">
        {/* Background container - isolated to prevent blend from affecting content */}
        <div className="absolute inset-0 isolate">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: 'url(/img/textures/texture.png)' }}
          />

          {/* Orange tint with soft-light blend */}
          <div className="absolute inset-0 bg-orange-1000/50 mix-blend-soft-light" />

          {/* Additional orange layer for warmth */}
          <div className="absolute inset-0 bg-orange-1000/40" />
        </div>

        {/* Content - completely above background layers */}
        <div className="relative z-20 flex flex-col items-center justify-center gap-[var(--spacing-48)] h-full p-[var(--spacing-48)] max-md:gap-[var(--spacing-32)] max-md:p-[var(--spacing-32)]">
          <div className="flex flex-col items-center gap-[var(--spacing-16)] text-center">
            <Typography as="h2" variant="display" className="!text-orange-200">
              Hire Archie
            </Typography>
            <Typography as="p" variant="h2" className="!text-orange-200">
              Expand your team's capacity without adding headcount.
            </Typography>
          </div>

          <Link
            to="/contact-sales"
            onClick={() =>
              trackEvent('cta_clicked', {
                cta_text: 'Bring Archie On Board',
                cta_location: 'hire_archie_cta',
                cta_href: '/contact-sales',
              })
            }
          >
            <button className="inline-flex items-center justify-center gap-[var(--spacing-8)] px-[var(--spacing-16)] py-[var(--spacing-12)] rounded-[var(--radius-8)] font-body text-[16px] leading-[24px] font-normal transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 bg-orange-200 text-orange-1000 hover:bg-orange-800 hover:text-white focus:ring-orange-200">
              Bring Archie On Board
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};
